var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321.75 45.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.41c3.3-10.19,32.63-9.83,65.52.81s56.87,27.53,53.58,37.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.75,8.33c-3.1-10.25-32.44-10.46-65.52-.46s-57.41,26.41-54.31,36.66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset46);
export default __webpack_public_path__ + "static/media/Asset 46.738fa89b.svg";
export { ForwardRef as ReactComponent };